import Card from "@mui/joy/Card";
import CardOverflow from "@mui/joy/CardOverflow";
import AspectRatio from "@mui/joy/AspectRatio";
import CardContent from "@mui/joy/CardContent";
import Typography from "@mui/joy/Typography";
import React from "react";

const StepsContent = ({heading, content}) => {
    return (
        <Card className={'tour-card'} variant="outlined" sx={{ width: 280, boxShadow: 0 }}>
            <CardOverflow>
                <AspectRatio ratio="2">
                    <img
                        src="https://images.unsplash.com/photo-1532614338840-ab30cf10ed36?auto=format&fit=crop&w=318"
                        srcSet="https://images.unsplash.com/photo-1532614338840-ab30cf10ed36?auto=format&fit=crop&w=318&dpr=2 2x"
                        loading="lazy"
                        alt=""
                    />
                </AspectRatio>
            </CardOverflow>
            <CardContent>
                <Typography level="h4">
                    {heading}
                </Typography>
                <Typography level="body-sm">
                    {content}
                </Typography>
            </CardContent>
        </Card>
    )
}

export const steps = [
    {
        selector: '.step-1',
        content: <StepsContent heading={'Start with a Text'} content={'Browse thousands of professionally designed templates for posts, videos, flyers and more.'}/>,
    },
    {
        selector: '.step-2',
        content: <StepsContent heading={'Start with a template'} content={'Browse thousands of professionally designed templates for posts, videos, flyers and more.'}/>,
    },
    {
        selector: '.step-3',
        content: <StepsContent heading={'Start with a template'} content={'Browse thousands of professionally designed templates for posts, videos, flyers and more.'}/>,
    },
    {
        selector: '.step-4',
        content: <StepsContent heading={'Start with a template'} content={'Browse thousands of professionally designed templates for posts, videos, flyers and more.'}/>,
    },
    {
        selector: '.step-5',
        content: <StepsContent heading={'Start with a template'} content={'Browse thousands of professionally designed templates for posts, videos, flyers and more.'}/>,
    },
    {
        selector: '.step-6',
        content: <StepsContent heading={'Start with a template'} content={'Browse thousands of professionally designed templates for posts, videos, flyers and more.'}/>,
    },
    {
        selector: '.step-7',
        content: <StepsContent heading={'Start with a template'} content={'Browse thousands of professionally designed templates for posts, videos, flyers and more.'}/>,
    },
    {
        selector: '.step-8',
        content: <StepsContent heading={'Start with a template'} content={'Browse thousands of professionally designed templates for posts, videos, flyers and more.'}/>,
    }
];